import { css } from '@emotion/css';
import { Match, onMount } from 'solid-js';
import { IAnimation } from 'Shared/frontend/themes/standardStyles';
import { Switch } from 'solid-js';


export function AnimationWrap(P:{children,animations?:IAnimation[]})
{
	let node!:HTMLElement;

	const animationsExist = () => (P.animations ?? []).length > 0;

	if (animationsExist()) {
		onMount(() => {
			for (const animation of P.animations) {
				const className = css(animation.css);

				const handleIntersection = (entries, observer) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							//XXX is using firstElementChild hacky here or good?	
							entry.target.firstElementChild?.classList.add(className);

							if (animation.type=='enableOnce')
								observer.unobserve(entry.target);
						}

						if (!entry.isIntersecting && animation.type=='enable') 
							entry.target.firstElementChild?.classList.remove(className);
					});
				};

				const observer = new IntersectionObserver(handleIntersection, animation.options);
				observer.observe(node);

				//XXX dont think (additional) cleanup is necessary
			}
		});
	}

//TODO could the <div> here could problems when using 'Fit content'? Haven't really thought it through. cf parallax and ignorePageMargins too...

	return (
		<Switch>
			<Match when={animationsExist()}>
				<div ref={node}>
					{P.children}
				</div>
			</Match>
			<Match when={true}>
				{P.children}
			</Match>
		</Switch>
	);
}

